import { connect } from 'react-redux';
import { wrapWithDispatch } from '../../utils';
import {
    validationChange,
    GaActionCreators,
} from './AppointmentRequirementsActions';
import { AppointmentRequirementsContainer } from './AppointmentRequirementsContainer';
import requirementsSelector from './AppointmentRequirementsSelector';
import * as Constants from './constants';
import { hasRequirement } from './helpers';

function checkBoxRequirementValidIfRequired(
    name,
    requirementsStore,
    providedRequirements
) {
    if (!hasRequirement(name, providedRequirements)) {
        return true;
    }

    const rootKey = Constants.warningMapping[name];

    return requirementsStore[rootKey].value;
}

function textRequirementValidIfRequired(
    name,
    requirementsStore,
    providedRequirements
) {
    if (!hasRequirement(name, providedRequirements)) {
        return true;
    }

    const rootKey = Constants.warningMapping[name];

    return requirementsStore[rootKey].value.trim() !== '';
}

function validateAppointmentRequirements(
    requirementsStore,
    providedRequirements
) {
    const checkBoxIsValid = (name) =>
        checkBoxRequirementValidIfRequired(
            name,
            requirementsStore,
            providedRequirements
        );
    const textBoxIsValid = (name) =>
        textRequirementValidIfRequired(
            name,
            requirementsStore,
            providedRequirements
        );
    const addressRequired = hasRequirement(
        Constants.ADDRESS_CONFIRMATION,
        providedRequirements
    );

    return (
        textBoxIsValid(Constants.REFERRAL_REQUIRED) &&
        checkBoxIsValid(Constants.PRIMARY_CARE_WARNING) &&
        checkBoxIsValid(Constants.OBGYN_WARNING) &&
        checkBoxIsValid(Constants.AGE_WARNING) &&
        (!addressRequired ||
            requirementsStore[Constants.ADDRESS_FORM_STATE_KEY].isValid)
    );
}

export function mapStateToProps(state, ownProps) {
    const appointmentRequirements = requirementsSelector(state);
    const { requirements } = ownProps;

    return {
        appointmentRequirements,
        isValid: validateAppointmentRequirements(
            appointmentRequirements,
            requirements
        ),
    };
}

export const mapDispatchToProps = (dispatch) => ({
    validationChange: (isValid) => {
        dispatch(validationChange(isValid));
    },
    ...wrapWithDispatch(GaActionCreators, dispatch),
});

export const AppointmentRequirementsConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(AppointmentRequirementsContainer);
